import styled from "styled-components";
import Navbar from "react-bootstrap/Navbar";
import Button from "react-bootstrap/Button";
import Row from "react-bootstrap/Row";
import bg from "../../../assets/Trama-LatamChequea3 1.png"
import { Container } from "react-bootstrap";

export const WrapperHeader = styled(Container)`
background-image: url(${bg});

`

export const StyledRowLogo = styled.div`
  a {
    color: #d53a23;
    padding: 0px;
    font-weight: 700;
    text-decoration: none;
    font-size: 28px;
    line-height: 24px;
  }
  @media screen and (min-width: 321px) and (max-width: 400px){
    a {
      font-size: 18px;
      line-height: 18px;
    }
  }
  @media screen and (min-width: 500px) and (max-width: 553px){
    a {
      font-size: 20px;
      line-height: 18px;
    }
  }
  @media (max-width: 320px) {
    a {
      font-size: 18px;
      line-height: 18px;
    }
  }
`;

export const StyledLive = styled.span`
  color: #d53a23;
  border-radius: 2px;
  display: block;
  font-size: 28px;
  margin-top: 4px;
`;

export const StyleIconQs = styled.div`
 svg {
   font-size: 2.5em;
   color: #d53a23;
 }
 @media (max-width: 320px) {
  svg {
    font-size: 1em;
    line-height: 18px;
  }
  @media screen and (min-width: 321px) and (max-width: 364px){
  }
  @media (max-width: 320px) {
    svg {
      font-size: 1em;
      line-height: 18px;
    }
}
`

export const StyledBtn = styled(Button)`
    color: #fff !important;
    background-color: #354052 !important;
    border: none;
    border-radius: 0;
    font-weight: bold;
    font-size: 1.5em;
    border-radius: 22px;
  &:hover {
   color: #354052 !important;
   background-color: #dbe0e5 !important;
  }
  &:active {
   color: #354052 !important;
   background-color: #dbe0e5 !important;
  }
  &:focus {
    box-shadow: none !important;
  }
  @media (max-width: 768px) {
    color: #374051 !important;
    background-color: #f8f9fa !important;
    border: 0!important;
  }
}
`;

export const StyledBtnAction = styled(Button)`
  color: #fff !important;
  background-color: #354052 !important;
  border: none;
  border-radius: 0;
  font-weight: bold;
  font-size: 1.5em;
  &:hover {
    color: #354052 !important;
    background-color: #dbe0e5 !important;
  }
  &:focus {
    box-shadow: none !important;
  }
  @media (max-width: 768px) {
    color: #374051 !important;
    background-color: #f8f9fa !important;
    border: 0 !important;
  }
`;

export const StyleLegend = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  border-left: 4px solid #d53a23;
  padding-left: 15px;
  padding-top:4px
`;

export const StyleBrand = styled(Navbar.Brand)`
  .imageLogo {
    display: block;
  }
  .imageLogoTilde {
    display: none;
  }
  @media (max-width: 500px) {
    .imageLogo {
      display: none;
    }
    .imageLogoTilde {
      width: 50px;
      display: block;
      margin: 0;
    }
  }
  @media (max-width: 320px) {
    .imageLogo {
      display: none;
    }
    .imageLogoTilde {
      width: 25px;
      display: block;
      margin: 0;
    }
  }
  padding:0;
  margin:0;
  display:block;
`;


export const StyledUlSocial = styled.ul`
  flex-direction: row;
  display: flex;
  list-style: none;
  padding: 0.25rem !important;
  margin: 0px;
  justify-content: flex-end;
  align-items: center;
  @media (max-width: 768px) {
    display: flex;
    flex-direction: column;
  }
  a {
    padding: 0.5rem !important;
    color: #364152;
  }
  a:hover {
    color: #F62D54 !important;
    font-weight: bold;
  }
  img {
    width: 30px;
  }
  li {
    padding-right: 20px;
    font-size: 14px;
    line-height: 13px;
    cursor: pointer;
    @media (max-width: 1024px) {
      font-size: 10px;
    }
    @media (max-width: 991px) {
        padding-right: 10px;
        margin-top: 10px;
    }
  }

  .icons {
    display: flex;
  }

  @media (max-width: 500px) {
    justify-content: center;
    margin-top: 20px;
  }

`;


export const StyledScroll = styled(Row)`
/* width */
::-webkit-scrollbar {
  width: 5px;
}

/* Track */
::-webkit-scrollbar-track {
  box-shadow: inset 0 0 5px grey; 
  border-radius: 10px;
}
 
/* Handle */
::-webkit-scrollbar-thumb {
  background: #354052; 
  border-radius: 19px;
}
`;
